<template>
	<div class="md:hidden">
		<DismissableBanner :show-when="true" resource-prefix="mobile-desktop-recommendation">
			{{ $t('general.mobile-desktop-recommendation') }}
		</DismissableBanner>
	</div>
</template>

<script>
import DismissableBanner from './DismissableBanner'

export default {
	name: 'MobileDesktopRecommendationBanner',
	components: {
		DismissableBanner
	}
}
</script>
